/* unplugin-vue-components disabled */import { ElEmpty as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/empty/style/css';
import { ElInput as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElSelect as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElCheckbox as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1038c049"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cascader-box"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "支付方式", -1));
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "right"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "参数配置", -1));
const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = {
  key: 0,
  class: "params-box"
};
const _hoisted_11 = {
  key: 0
};
import { apiUsdkCheckParams, apiUsdkGetGoodsConfEdit, apiUsdkGetProductId, apiUsdkSaveInternalPaySwitchConf } from '@/api/usdk';
import UseConfig from '../configHook';
import UseLoginPay from '../loginPayHooks';
import { UseGlobalConfig } from '@/utils/hooks';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  __name: 'internalPay',
  props: {
    gid: {
      type: [Number, String],
      required: true,
      default: 0
    },
    channel: {
      type: Object,
      required: true,
      default: () => ({})
    },
    payParams: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['ok'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const {
      $channel
    } = UseGlobalConfig();
    const {
      createCnames
    } = UseLoginPay();
    const {
      internalPay,
      payIcon
    } = UseConfig();
    const confirmLoading = ref(false);
    const productId = ref('');
    const serverId = ref('');
    const getProductId = () => {
      apiUsdkGetProductId({
        gid: props.gid,
        cid: props.channel.cid
      }).then(res => {
        if (res.code === 0) {
          productId.value = res.data.productId;
          serverId.value = res.data.serverId;
        }
      });
    };
    const form = ref({
      payConf: {}
    });
    const oldForm = ref({});
    watch(() => props.payParams, _params => {
      let params = {
        ..._params
      };
      console.log(params);
      if (params.usdkCid) {
        if (!params.payConf) {
          params.payConf = {};
          internalPay.forEach(item => {
            if (item.params) {
              item.params.forEach(p => {
                params.payConf[p.key] = '';
              });
            }
          });
        }
        form.value = JSON.parse(JSON.stringify(params));
        oldForm.value = JSON.parse(JSON.stringify(params));
        getProductId();
      }
    }, {
      immediate: true
    });
    const currentPay = ref({});
    const handleClick = params => {
      currentPay.value = params;
    };
    const getGoodsConf = async () => {
      let temp = 0;
      const res = await apiUsdkGetGoodsConfEdit({
        gid: props.gid,
        cid: props.channel.cid
      });
      if (res.code === 0) {
        if (props.channel.channel === $channel.OFFICIAL_IOS_CHANNEL) {
          res.data.forEach(item => {
            if (!item.iosGoodsId) {
              temp++;
            }
          });
        } else {
          res.data.forEach(item => {
            if (!item.channelGoodsId) {
              temp++;
            }
          });
        }
      }
      return temp;
    };
    const formatValue = data => {
      const result = {};
      for (const key in data) {
        if (key === 'payConf') {
          for (const k in data[key]) {
            result[k] = data[key][k];
          }
        } else {
          result[key] = data[key];
        }
      }
      return result;
    };
    const emits = __emit;
    const handleSubmit = async () => {
      let serverCnames = '';
      let productCnames = '';
      await apiUsdkCheckParams({
        gid: props.gid,
        cid: props.channel.cid,
        type: 1
      }).then(res => {
        if (res.code === 0) {
          serverCnames = createCnames(res.data.serverId);
          productCnames = createCnames(res.data.productId);
        }
      });
      const dict = {};
      internalPay.map(item => {
        dict[`type${item.type}`] = {
          name: item.label
        };
        if (item.params) {
          item.params.map(i => {
            dict[i.key] = {
              name: i.label
            };
          });
        }
      });
      const newData = formatValue(form.value);
      const oldData = formatValue(oldForm.value);
      let countIsNull = 0;
      if (oldForm.value['type16'] === 0 && form.value['type16'] === 1) {
        countIsNull = await getGoodsConf();
      }
      ElMessageBox.confirm(`你正在编辑修改${props.channel.name}渠道支付开关/参数，修改后将直接立即影响线上游戏支付，请务必确认操作无误后再保存，否则因此导致的线上游戏支付事故后果自负！
      ${serverCnames ? `系统检测到${serverCnames}所配置的区服ID与当前渠道一致，均为${serverId.value}，因此如本次修改保存了支付方式开关，则支付方式的修改会一并对上述所有渠道生效。` : ''}
      ${productCnames ? `系统检测到${productCnames}所配置的ProductID与当前渠道一致，均为${productId.value}，因此如本次修改保存了支付方式参数，则支付方式的修改会一并对上述所有渠道生效。` : ''}
			${!!countIsNull ? `<span style="color: #e99840">系统检测到${props.channel.channel === $channel.OFFICIAL_IOS_CHANNEL ? '苹果支付' : props.channel.name + '支付'}下有${countIsNull}个商品未配置渠道商品ID!</span>` : ''}`, '提示', {
        customStyle: {
          width: '800px'
        },
        confirmButtonText: '取消，不保存',
        cancelButtonText: '确认保存',
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => {
        // to do
      }).catch(action => {
        if (action === 'cancel') {
          confirmLoading.value = true;
          return apiUsdkSaveInternalPaySwitchConf({
            gid: props.gid,
            cids: props.channel.cid,
            ...form.value
          }).then(res => {
            if (res.code === 0) {
              emits('ok');
              customDataReport({
                eventName: 'set_internal_pay_switch_params',
                dict,
                before: oldData,
                after: newData,
                operatePath: '运营-登录支付配置-支付和商品管理-国内支付',
                gid: props.gid
              });
              oldForm.value = JSON.parse(JSON.stringify(form.value));
            }
          }).finally(() => {
            confirmLoading.value = false;
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_checkbox = __unplugin_components_1;
      const _component_u_question = _resolveComponent("u-question");
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_option = __unplugin_components_3;
      const _component_el_select = __unplugin_components_4;
      const _component_el_input = __unplugin_components_5;
      const _component_el_empty = __unplugin_components_6;
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
        to: "#internalPay"
      }, [_createVNode(_component_el_button, {
        loading: _unref(confirmLoading),
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("保存")]),
        _: 1
      }, 8, ["loading"])])), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(internalPay).filter(pay => props.channel.channel === _unref($channel).OFFICIAL_IOS_CHANNEL ? pay.type === 16 : pay.type !== 16), item => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.type
        }, [props.channel.channel != 'ultrah5' || props.channel.channel === 'ultrah5' && [81, 88].includes(item.type) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['check-item', item.type === _unref(currentPay).type ? 'active-check-item' : '']),
          onClick: $event => handleClick(item)
        }, [_createVNode(_component_el_checkbox, {
          modelValue: _unref(form)['type' + item.type],
          "onUpdate:modelValue": $event => _unref(form)['type' + item.type] = $event,
          "false-label": 0,
          "true-label": 1,
          class: "marginR5"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createElementVNode("img", {
          src: _unref(payIcon)[item.icon],
          style: {
            "margin-right": "3px"
          },
          width: "20"
        }, null, 8, _hoisted_6), _createTextVNode(_toDisplayString(item.label) + " ", 1), item.tips ? (_openBlock(), _createBlock(_component_u_question, {
          key: 0,
          content: item.tips
        }, null, 8, ["content"])) : _createCommentVNode("", true)], 10, _hoisted_5)) : _createCommentVNode("", true)], 64);
      }), 128))])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_unref(currentPay).params ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_form_item, {
        label: "渠道"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.channel.name), 1), _unref(productId) ? (_openBlock(), _createElementBlock("span", _hoisted_11, "(" + _toDisplayString(_unref(productId)) + ")", 1)) : _createCommentVNode("", true)]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentPay).params, p => {
        return _openBlock(), _createBlock(_component_el_form_item, {
          key: p.key
        }, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString(p.label) + " ", 1), p.tips ? (_openBlock(), _createBlock(_component_u_question, {
            key: 0,
            content: p.tips
          }, null, 8, ["content"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [p.options ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            modelValue: _unref(form).payConf[p.key],
            "onUpdate:modelValue": $event => _unref(form).payConf[p.key] = $event
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.options, op => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: op.value,
                label: op.label,
                value: op.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])) : (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            modelValue: _unref(form).payConf[p.key],
            "onUpdate:modelValue": $event => _unref(form).payConf[p.key] = $event
          }, null, 8, ["modelValue", "onUpdate:modelValue"]))]),
          _: 2
        }, 1024);
      }), 128))])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "不需要配置参数"
      }))])])])], 64);
    };
  }
});